




























import Component from 'vue-class-component';
import {IDictionary} from '@/entities/dictionary.interface';
import {IFormControl} from '@/entities/form.interface';
import {EditPage} from '@/components/base/edit/edit-page';
import * as types from '@/store/types';
import {mapGetters} from 'vuex';
import profileApi from '@/api/profile.api';
import optionsApi from '@/api/options.api';
import {IOptionsUpdateModel} from '@/entities/options';

@Component({
    computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class OptionsEditComponent extends EditPage {
    public parentPath: string = '/app/settings/options';

    public superadminPermissions;

    public formState: IDictionary<IFormControl> = {
        auto_block_account: {
            key: 'auto_block_account',
            label: 'Аuto Block Account',
            value: '',
            validators: ''
        }
    };

    public async created() {
        await super.created();
        this.isNew = false;
        this.loading = true;
        try {
            const options = await optionsApi.get();
            let optionsBody = {};
            options.forEach((option) => {
                switch (option.name) {
                    case 'auto_block_account':
                        optionsBody[option.name] = Boolean(Number(option.value));
                        break;
                    default:
                        optionsBody[option.name] = option.value;
                }
            });
            this.setValues(optionsBody);
        } finally {
            this.loading = false;
        }
    }

    protected create(id: number): Promise<any> {
        throw new Error('not supported');
    }

    protected detail(body: any): Promise<any> {
        throw new Error('not supported');
    }

    protected update(body: any): Promise<void> {
        const values: IOptionsUpdateModel[] = [];
        Object.keys(body).forEach((key: string) => {
            values.push({name: key, value: this.formState[key].value});
        });

        return optionsApi.update(values);
    }
}
